import { Component, ViewChild } from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import {
  RevenueManagementBaseData, RevenueManagementAirlineCodes, RevenueManagementAirports,
  RevenueManagementProperties, RevenueManagementCalculationFlight,
  Supplier_OficeID,
  RevenueManagementSupplierFlights,
  RevenueManagementFlightLocationProperties,
  RevenueManagement_AirlineFlight, AirlineControlType, RefundRevenueCalculateProperties
} from "../Models/RevenueManagementProperties";
import { FormControl, FormGroup, FormBuilder, Validators, FormsModule } from '@angular/forms';
import { RevenueManagementService } from "../Services/revenue-management.service";
import { HttpClient, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http'
import { Router, RouterLink } from "@angular/router";
import { ActiveSuppliers, Agency_Branches } from "../Models/ActiveClasses";
import { NgSelectComponent, NgSelectModule } from "@ng-select/ng-select";
// import { createBreak } from "typescript";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NavMenuComponent } from "../nav-menu/nav-menu.component";
import { AsyncPipe } from "@angular/common";
declare var $;

@Component({
    selector: 'app-refund-revenue',
    templateUrl: './refund-revenue.component.html',
    styleUrls: ['./refund-revenue.component.css'],
    imports: [NavMenuComponent, FormsModule, NgSelectModule, RouterLink, AsyncPipe]
})
/** RefundRevenue component*/

export class RefundRevenueComponent {
  @ViewChild('oficeId') ddlOficeId: NgSelectComponent;
  @ViewChild('agency_brancch') ddlAgency_branch: NgSelectComponent;
  @ViewChild('supplier') ddlSupplier: NgSelectComponent;
  @ViewChild('airportFrom') fromAirport: NgSelectComponent;
  @ViewChild('airportTo') toAirport: NgSelectComponent;
  agency_branchesList$: Observable<Agency_Branches[]>;
  supplierList$: Observable<ActiveSuppliers[]>;
  activeSuppliers: ActiveSuppliers[] = [];
  revenueObj = new RevenueManagementProperties();
  oficeIdList$: Observable<Supplier_OficeID[]>;
  supplier_oficeIdData: Supplier_OficeID[] = [];
  suppliersDatanew: RevenueManagementSupplierFlights[] = [];
  selectedFromLocation: string[] = [];
  selectedToLocation: string[] = [];
  selectedVIALocation: string[] = [];
  validatecheckmessage: string = "You Have Already Applied this Criteria! Please Change the Criteria On or Use Old Criteria";
  validateforwardmessage: string = "If You Want To use Old One Click On Yes Button";
  movedToRevenueOnYes: number = 0;
  allBaseData$: RevenueManagementBaseData;
  revenueData$: RevenueManagementProperties;

  airportsList$: Observable<RevenueManagementAirports[]>;
  airlineList$: Observable<RevenueManagementAirlineCodes[]>;

  flightCalculations: RevenueManagementCalculationFlight[] = [];
  selectedSuppliers: string[] = [];
  selectedOficeIds: string[] = [];

  selectedValidatingAirline: string[] = [];
  selectedMarkitingAirline: string[] = [];
  selectedOperatingAirline: string[] = [];
  //originalAirlines: RevenueManagementAirlineCodes[] = [];
  //originalAirports: RevenueManagementAirports[] = [];
  saveData = false;
  excludedFromLocation: string[] = [];
  excludedToLocation: string[] = [];
  excludedVIALocation: string[] = [];

  buttonName: string = "Save";
  passengerTypeList = [
    { type: "Adult" },
    { type: "Child" },
    { type: "Infant" },
  ];
  cabinClassList = [
    { cabinType: "First" },
    { cabinType: "Business" },
    { cabinType: "Economy" },
    { cabinType: "ALL" },
  ];
  rbdList = [
    { rbdType: "A" },
    { rbdType: "B" },
    { rbdType: "C" },
    { rbdType: "D " },
    { rbdType: "E" },
    { rbdType: "F" },
    { rbdType: "G" },
    { rbdType: "H" },
    { rbdType: "I" },
    { rbdType: "J" },
    { rbdType: "K" },
    { rbdType: "L" },
    { rbdType: "M" },
    { rbdType: "N" },
    { rbdType: "O" },
    { rbdType: "P" },
    { rbdType: "Q" },
    { rbdType: "R" },
    { rbdType: "S" },
    { rbdType: "T" },
    { rbdType: "U" },
    { rbdType: "V" },
    { rbdType: "W" },
    { rbdType: "X" },
    { rbdType: "Y" },
    { rbdType: "Z" },
    { rbdType: "ALL" },

  ];

  calculatedOnList = [
    { calculateType: "Base Fare" },
    { calculateType: "Total Fare" },
  ];

  ddlTypeList = [
    { item: "Agency", id: 1 },
    { item: "Branch", id: 2 },
    { item: "All", id: 3 },

  ];
  /*=====Type Section====*/
  isMarkup = false;
  isDiscount = false;
  isServiceFee = false;
  isCommission = false;
  isRefund = false;
  isReissue = false;
  isAirlineCommission = false;
  //End

  /*=====Applies On====*/
  isPassenger = false;
  isPNR = false;
    minDate: string="";
  //End
  constructor(private FallSuccess: NgbModal, public revenueService: RevenueManagementService, private router: Router) {

  }
  ngOnInit() {
    this.revenueService.GetRevenueManagementAgencies_Branches(localStorage.getItem("AgencyId")).subscribe((data) => {
      this.agency_branchesList$ = of(data);
      this.AddFlightCalculation();
      //this.GetRevenueBaseData();
      /*      this.CheckRevenueManagementRights();*/
      this.getbasedata();
      this.isPassenger = true;
      this.isPNR = false;
      this.revenueObj.appliesOn = "Passenger";
      const today = new Date();
      this.minDate = today.toISOString().split('T')[0];
    })


  }
  //CheckRevenueManagementRights() {
  //  this.revenueService.CheckRightsAgaintAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data) => {
  //    if (data) {

  //      $("#btnSave").removeAttr("disabled");
  //    }
  //    else {
  //      $("#btnSave").attr("disabled", "disabled");
  //    }
  //  });
  //}
  GetRevenueBaseData() {
    try {
      this.revenueService.GetRevenueBaseData().subscribe((data) => {
        this.allBaseData$ = data;
        this.airlineList$ = of(this.allBaseData$.airlines);
        let airport = new RevenueManagementAirports();
        airport.cityName = "World Wide";
        airport.iATA_CODE = "World Wide";
        this.allBaseData$.airports.push(airport);
        this.airportsList$ = of(this.allBaseData$.airports);
        if ((localStorage.getItem("RevenueManagementListId") != undefined) && (localStorage.getItem("RevenueManagementListId") != "")) {
          let revenueId = localStorage.getItem("RevenueManagementListId");
          this.buttonName = "Update";
          localStorage.removeItem("RevenueManagementListId");
          this.revenueService.GetRevenuevoidrefundById(revenueId).subscribe((data) => {
            this.revenueObj = data;
            if (this.revenueObj != null && this.revenueObj != undefined) {

              //this.ChangeAppliesOn(this.revenueObj.appliesOn);
              this.newbind(this.revenueObj);
            }
          })
        }
      })
    }
    catch (e) {

    }
  }
  getbasedata() {
    if ((localStorage.getItem("RevenueManagementListId") != undefined) && (localStorage.getItem("RevenueManagementListId") != "")) {
      let revenueId = localStorage.getItem("RevenueManagementListId");
      localStorage.removeItem("RevenueManagementListId");
      this.buttonName = "Update";
      this.revenueService.GetRevenuevoidrefundById(revenueId).subscribe((data) => {
        this.revenueObj = data;
        //for (let o = 0; o < this.revenueObj.flightCalaculationData.length; o++) {
        //  if (this.revenueObj.flightCalaculationData[o].valueAmount > 0) {
        //    this.flightvaluesamountchanges(o, this.revenueObj.flightCalaculationData[o].valueAmount)
        //  }
        //  else if (this.revenueObj.flightCalaculationData[o].valuePercent > 0) {
        //    this.flightvaluespercentchanges(o, this.revenueObj.flightCalaculationData[o].valuePercent)
        //  }
        //}
        this.ChangeType(this.revenueObj.type);
        if (this.revenueObj != null && this.revenueObj != undefined) {


          this.newbind(this.revenueObj);

        }
      })
    }

  }
  newbind(obj: RevenueManagementProperties) {
    //this.revenueObj.selectedSuppliersList = [];
    //this.revenueObj.selectedOficeIdsList = [];
    //for (let i = 0; i < this.revenueObj.suppliersData.length; i++) {

    //  this.revenueObj.selectedSuppliersList.push(this.revenueObj.suppliersData[i].supplierId);
    //  this.revenueObj.selectedOficeIdsList.push(this.revenueObj.suppliersData[i].officeId);
    //}

    let agency_branch = obj.agencyId_BranchId;
    this.ddlAgency_branch.handleClearClick();
    obj.agencyId_BranchId = agency_branch;

    this.revenueService.GetRevenueManagementAgencies_Branches(localStorage.getItem("AgencyId")).subscribe((data) => {
      this.agency_branchesList$ = of(data);
    })
    
    this.revenueService.GetRevenueManagementSupplierByParent(localStorage.getItem("AgencyId")).subscribe((result) => {
      this.ddlSupplier.handleClearClick();
      this.activeSuppliers = result;
      this.supplierList$ = of(result);
      this.revenueObj.selectedSuppliersList = [];
      for (let i = 0; i < this.activeSuppliers.length; i++) {
        let mainList = this.activeSuppliers[i];
        for (let j = 0; j < this.revenueObj.suppliersData.length; j++) {
          let listItem = this.revenueObj.suppliersData[j];
          if (mainList.supplierId == listItem.supplierId) {


            this.revenueObj.selectedSuppliersList.push(listItem.supplierId);

            break;
          }
        }
      }
      if (this.revenueObj.selectedSuppliersList.length > 0) {

        this.revenueService.GetRevenueManagementOficeIds(this.revenueObj.selectedSuppliersList.toString()).subscribe((oficeIdData) => {
          this.oficeIdList$ = of(oficeIdData);
          this.supplier_oficeIdData = oficeIdData;
          this.revenueObj.selectedOficeIdsList = [];
          for (let i = 0; i < this.supplier_oficeIdData.length; i++) {
            let mainList = this.supplier_oficeIdData[i];
            for (let j = 0; j < this.revenueObj.suppliersData.length; j++) {
              let listItem = this.revenueObj.suppliersData[j];
              if (mainList.officeId == listItem.officeId) {
                this.revenueObj.selectedOficeIdsList.push(listItem.officeId);

              }
            }
          }
        })
      }

    })


    //this.selectedFromLocation = [];
    //this.selectedToLocation = [];
    //if (this.revenueObj.flightLocationDataIncluded.length > 0) {
    //  this.selectedFromLocation = [...new Set(this.revenueObj.flightLocationDataIncluded.map(x => x.fromLocation))]
    //  this.selectedToLocation = [...new Set(this.revenueObj.flightLocationDataIncluded.map(x => x.toLocation))]
    //  this.selectedVIALocation = [...new Set(this.revenueObj.flightLocationDataIncluded.map(x => x.viaLocation))]
    //}

    //if (this.revenueObj.flightLocationDataExcluded.length > 0) {
    //  this.excludedFromLocation = [...new Set(this.revenueObj.flightLocationDataExcluded.map(x => x.fromLocation))]
    //  this.excludedToLocation = [...new Set(this.revenueObj.flightLocationDataExcluded.map(x => x.toLocation))]
    //  this.excludedVIALocation = [...new Set(this.revenueObj.flightLocationDataExcluded.map(x => x.viaLocation))]
    //}
    //this.selectedValidatingAirline = [];
    //this.selectedMarkitingAirline = [];
    //this.selectedOperatingAirline = [];
    //this.revenueObj.selectedValidatingAirlineList = [];
    //for (let j = 0; j < this.revenueObj.airlineFlightData.length; j++) {
    //  let listItem = this.revenueObj.airlineFlightData[j];
    //  if (listItem.airlineTypeId == 1) {
    //    this.selectedValidatingAirline.push(listItem.airlineId);
    //    this.revenueObj.selectedValidatingAirlineList.push(listItem.airlineId);
    //  }
    //  else if (listItem.airlineTypeId == 2)
    //    this.selectedMarkitingAirline.push(listItem.airlineId);
    //  else if (listItem.airlineTypeId == 3)
    //    this.selectedOperatingAirline.push(listItem.airlineId);
    //}
    if (this.revenueObj.flightCalaculationData.length > 0) {
      this.flightCalculations = [];
      for (let j = 0; j < this.revenueObj.flightCalaculationData.length; j++) {
        let listItem = this.revenueObj.flightCalaculationData[j];
        listItem.selectedRbd = [];
        listItem.selectedRbd = listItem.rbd.split(',');
        this.flightCalculations.push(listItem);
      }
    }

  }



  ChangeAgency_Branch(agency_branch) {
    try {
      this.ddlSupplier.handleClearClick();
      if (agency_branch.length == 1) {
        
        this.revenueService.GetRevenueManagementSupplierByParent(localStorage.getItem("AgencyId")).subscribe((data) => {
          this.supplierList$ = of(data);

        })
      }
      else {
        this.revenueService.GetRevenueManagementSupplierAll().subscribe((data) => {
          this.supplierList$ = of(data);

        })
      }
    }
    catch (e) {

    }
  }

  ChangeSupplier(selectedList) {
    try {
      if (selectedList.length > 0) {
        this.ddlOficeId.handleClearClick();
        let str = selectedList.toString();
        this.revenueService.GetRevenueManagementOficeIds(str).subscribe((data) => {
          this.oficeIdList$ = of(data);
          this.supplier_oficeIdData = data;

        })
      }
      else {
        this.ddlOficeId.handleClearClick();
        this.oficeIdList$ = of([]);
      }
    }
    catch (e) {

    }
  }
  ChangeDirection(e) {
    try {
      if (e.target.checked) {
        this.revenueObj.isDirection = true;
      }

    }
    catch (e) {

    }
  }
  reveuecheckcriteria: RefundRevenueCalculateProperties[] = [];
  onSaveData(model, targetmodel) {
    let agencyid = localStorage.getItem("AgencyId")
    if (this.revenueObj.revenueId == 0 || this.revenueObj.revenueId == undefined || this.revenueObj.revenueId == null) {
      this.revenueService.GetRevenueByAgencyId(agencyid, 2).subscribe((data) => {
        this.reveuecheckcriteria = data;
        this.RefundRequestSave(model, targetmodel);

      })

    }
    else if (this.revenueObj.revenueId > 0) {


      this.RefundRequestUpdate(model);
    }
  }
  valueamountflight: boolean = false;
  valuePercentflight: boolean = false;
  flightvaluesamountchanges(i, param) {
    if (param > 0) {
      var value = document.getElementById(`valuePercent${i}`) as HTMLInputElement;
      value.disabled = true;
      this.flightCalculations[i].valuePercent = 0;

    }
    else {
      var value = document.getElementById(`valuePercent${i}`) as HTMLInputElement;
      value.disabled = false;
      this.flightCalculations[i].valueAmount = 0;
    }

  }
  flightvaluespercentchanges(i, param) {
    if (param > 0) {
      var value = document.getElementById(`valueAmount${i}`) as HTMLInputElement;
      value.disabled = true;
      this.flightCalculations[i].valueAmount = 0;

    }
    else {
      var value = document.getElementById(`valueAmount${i}`) as HTMLInputElement;
      value.disabled = false;
      this.flightCalculations[i].valuePercent = 0;
    }

  }
  RefundRequestSave(model, targetmodel) {
    if (this.revenueObj.name == undefined || this.revenueObj.name == "") {
      document.getElementById("messagename").innerHTML = "Required Name";
      document.getElementById("name").classList.add("newRequired-BoxColor");
      setTimeout(function () {
        document.getElementById("messagename").innerHTML = "";
        document.getElementById("name").classList.remove("newRequired-BoxColor");
      }, 6000);
      return;
    }
    if (this.revenueObj.agencyBranchList.length < 1) {
      document.getElementById("messageagency").innerHTML = "Required Agency";
      document.getElementById("agencybranch").classList.add("newRequired-BoxColor");
      setTimeout(function () {
        document.getElementById("messageagency").innerHTML = "";
        document.getElementById("agencybranch").classList.remove("newRequired-BoxColor");
      }, 6000);
      return;
    }
    if (this.revenueObj.expiryDate == undefined || this.revenueObj.expiryDate == "") {
      document.getElementById("messageexpiryDate").innerHTML = "Required Date";
      document.getElementById("expiryDate").classList.add("newRequired-BoxColor");
      setTimeout(function () {
        document.getElementById("messageexpiryDate").innerHTML = "";
        document.getElementById("expiryDate").classList.remove("newRequired-BoxColor");
      }, 6000);
      return;
    }
   if (this.revenueObj.selectedSuppliersList == undefined || this.revenueObj.selectedSuppliersList.length == 0) {
      document.getElementById("messagesupplierd").innerHTML = "Required Supplier";
      document.getElementById("supplierd").classList.add("newRequired-BoxColor");
      setTimeout(function () {
        document.getElementById("messagesupplierd").innerHTML = "";
        document.getElementById("supplierd").classList.remove("newRequired-BoxColor");
      }, 6000);
      return;
    }
if (this.revenueObj.selectedOficeIdsList.length == 0) {
      document.getElementById("messageisOficeId").innerHTML = "Required OfficeID";
      document.getElementById("abc").classList.add("newRequired-BoxColor");
      setTimeout(function () {
        document.getElementById("messageisOficeId").innerHTML = "";
        document.getElementById("abc").classList.remove("newRequired-BoxColor");
      }, 6000);
      return;
    }
    if (this.revenueObj.isOficeId == undefined || this.revenueObj.isOficeId == false) {
      document.getElementById("messageisOficeId").innerHTML = "Required OfficeID CheckBox";
      document.getElementById("checkoffice").classList.add("newRequired-BoxColor");
      setTimeout(function () {
        document.getElementById("messageisOficeId").innerHTML = "";
        document.getElementById("checkoffice").classList.remove("newRequired-BoxColor");
      }, 6000);
      return;
    }
    if (this.revenueObj.applyChildAgency == false && this.revenueObj.applyChildBranches == false && this.revenueObj.applyHO == false) {
      document.getElementById("messageApplyOn").innerHTML = "Required Minimum one CheckBox";

      setTimeout(function () {
        document.getElementById("messageApplyOn").innerHTML = "";

      }, 6000);
      return;
    }
    if (this.revenueObj.type == undefined || this.revenueObj.type == "" || this.revenueObj.type == null) {
      document.getElementById("messagetypesefe").innerHTML = "Required Type";

      setTimeout(function () {
        document.getElementById("messagetypesefe").innerHTML = "";

      }, 6000);
      return;
    }
    if (this.revenueObj.appliesOn.length == 0) {
      document.getElementById("messageApplied").innerHTML = "Required Applied";

      setTimeout(function () {
        document.getElementById("messageApplied").innerHTML = "";

      }, 6000);
      return;
    }
    //if (this.revenueObj.isTravelDate == true) {
    //  if (this.revenueObj.travelDateFrom.length <= 0) {
    //    document.getElementById("travelrequiredfrom").innerHTML = "Required From";

    //    setTimeout(function () {
    //      document.getElementById("travelrequiredfrom").innerHTML = "";

    //    }, 6000);
    //    return;
    //  }
    //  if (this.revenueObj.travelDateTo.length <= 0) {
    //    document.getElementById("travelrequiredto").innerHTML = "Required To";

    //    setTimeout(function () {
    //      document.getElementById("travelrequiredto").innerHTML = "";

    //    }, 6000);
    //    return;
    //  }
    //}

    //if (this.revenueObj.travelDateFrom.length > 0 && this.revenueObj.travelDateTo == "") {
    //  document.getElementById("travelrequiredto").innerHTML = "Required To";

    //  setTimeout(function () {
    //    document.getElementById("travelrequiredto").innerHTML = "";

    //  }, 6000);
    //  return;
    //}
    //if (this.revenueObj.travelDateTo.length > 0 && this.revenueObj.travelDateFrom == "") {
    //  document.getElementById("travelrequiredfrom").innerHTML = "Required From";

    //  setTimeout(function () {
    //    document.getElementById("travelrequiredfrom").innerHTML = "";

    //  }, 6000);
    //  return;
    //}
    //if (this.revenueObj.travelDateFrom.length > 0 && this.revenueObj.travelDateTo.length > 0) {
    //  if (this.revenueObj.travelDateFrom > this.revenueObj.travelDateTo) {
    //    document.getElementById("travelrequiredfrom").innerHTML = "Carefully select From Or To Date";

    //    setTimeout(function () {
    //      document.getElementById("travelrequiredfrom").innerHTML = "";

    //    }, 6000);
    //    return;
    //  }
    //}
    //if (this.revenueObj.isBookingDate == true) {
    //  if (this.revenueObj.bookingDateFrom.length <= 0) {
    //    document.getElementById("bookingdateform").innerHTML = "Required From";

    //    setTimeout(function () {
    //      document.getElementById("bookingdateform").innerHTML = "";

    //    }, 6000);
    //    return;
    //  }
    //  if (this.revenueObj.bookingDateTo.length <= 0) {
    //    document.getElementById("bookingdateto").innerHTML = "Required To";

    //    setTimeout(function () {
    //      document.getElementById("bookingdateto").innerHTML = "";

    //    }, 6000);
    //    return;
    //  }
    //}


    //if (this.revenueObj.bookingDateFrom.length > 0 && this.revenueObj.bookingDateTo == "") {
    //  document.getElementById("bookingdateto").innerHTML = "Required To";

    //  setTimeout(function () {
    //    document.getElementById("bookingdateto").innerHTML = "";

    //  }, 6000);
    //  return;
    //}
    //if (this.revenueObj.bookingDateTo.length > 0 && this.revenueObj.bookingDateFrom == "") {
    //  document.getElementById("bookingdateform").innerHTML = "Required From";

    //  setTimeout(function () {
    //    document.getElementById("bookingdateform").innerHTML = "";

    //  }, 6000);
    //  return;
    //}
    //if (this.revenueObj.bookingDateFrom.length > 0 && this.revenueObj.bookingDateTo.length > 0) {
    //  if (this.revenueObj.bookingDateFrom > this.revenueObj.bookingDateTo) {
    //    document.getElementById("bookingdateform").innerHTML = "Carefully select From Or To Date";

    //    setTimeout(function () {
    //      document.getElementById("bookingdateform").innerHTML = "";

    //    }, 6000);
    //    return;
    //  }
    //}



    if (this.flightCalculations.length < 1
      || this.flightCalculations.length == null) {
      this.saveData = false;

      document.getElementById("requirefldmsg").innerHTML = "Please Enter Calculation Data";

      setTimeout(function () {
        document.getElementById("requirefldmsg").innerHTML = "";

      }, 6000);
      return;

    }

    for (let i = 0; i < this.flightCalculations.length; i++) {
      if (this.flightCalculations[i].cabinClass == "" || this.flightCalculations[i].cabinClass == null
        || this.flightCalculations[i].calculatedOn == "" || this.flightCalculations[i].calculatedOn == null
        || this.flightCalculations[i].passengerType.length<1 || this.flightCalculations[i].passengerType == null
        || this.flightCalculations[i].selectedRbd.length < 1 || this.flightCalculations[i].selectedRbd.length == null
        || (this.flightCalculations[i].valueAmount == 0 && this.flightCalculations[i].valuePercent == 0)) {

        document.getElementById("requirefldmsg").innerHTML = "Please Enter Calculation Data";

        setTimeout(function () {
          document.getElementById("requirefldmsg").innerHTML = "";

        }, 6000);
        return;
      }

      else {
        this.saveData = true;

      }
    }
    for (let i = 0; i < this.flightCalculations.length; i++) {
      if ((this.flightCalculations[i].valueAmount > 0 && this.flightCalculations[i].valuePercent > 0)) {

        document.getElementById(`valuePercentmessage${i}`).innerHTML = "Enter Only One Value Percent / Value Amount";

        setTimeout(function () {
          document.getElementById(`valuePercentmessage${i}`).innerHTML = "";

        }, 6000);
        return;
      }

      else {
        this.saveData = true;

      }
    }

    this.revenueObj.suppliersData = [];
    let userId = Number(localStorage.getItem("UserId"));
    if (userId != 0) {
      if (localStorage.getItem("AgencyId") != undefined &&
        localStorage.getItem("AgencyId") != null && localStorage.getItem("AgencyId") != "") {
        this.revenueObj.baseRuleAgency = localStorage.getItem("AgencyId");
      }

      if (this.revenueObj.selectedSuppliersList.length > 0 && this.revenueObj.selectedOficeIdsList.length > 0) {
        for (let i = 0; i < this.supplier_oficeIdData.length; i++) {
          for (let j = 0; j < this.revenueObj.selectedOficeIdsList.length; j++) {
            if (this.supplier_oficeIdData[i].officeId == this.revenueObj.selectedOficeIdsList[j]) {
              let obj = new RevenueManagementSupplierFlights;
              obj.officeId = this.supplier_oficeIdData[i].officeId;
              obj.supplierId = this.supplier_oficeIdData[i].supplierId;
              this.revenueObj.suppliersData.push(obj);
              break;
            }
          }
        }
      }
      else if (this.revenueObj.selectedSuppliersList.length > 0) {
        for (let i = 0; i < this.supplier_oficeIdData.length; i++) {
          let obj = new RevenueManagementSupplierFlights;
          obj.officeId = '*';
          obj.supplierId = this.supplier_oficeIdData[i].supplierId;
          this.revenueObj.suppliersData.push(obj);
          break;
        }

      }
      //if (this.revenueObj.isValidatingAirline == true) {
      //  for (let i = 0; i < this.selectedValidatingAirline.length; i++) {
      //    let obj = new RevenueManagement_AirlineFlight();
      //    obj.airlineTypeId = AirlineControlType.validatingAirline;
      //    obj.airlineId = this.selectedValidatingAirline[i];
      //    this.revenueObj.airlineFlightData.push(obj);
      //  }
      //}
      //if (this.revenueObj.isMarketingAirline == true) {
      //  for (let i = 0; i < this.selectedMarkitingAirline.length; i++) {
      //    let obj = new RevenueManagement_AirlineFlight();
      //    obj.airlineTypeId = AirlineControlType.marketingAirline;
      //    obj.airlineId = this.selectedMarkitingAirline[i];
      //    this.revenueObj.airlineFlightData.push(obj);
      //  }
      //}

      //if (this.revenueObj.isOperatingAirline == true) {
      //  for (let i = 0; i < this.selectedOperatingAirline.length; i++) {
      //    let obj = new RevenueManagement_AirlineFlight();
      //    obj.airlineTypeId = AirlineControlType.operatingAirline;
      //    obj.airlineId = this.selectedOperatingAirline[i];
      //    this.revenueObj.airlineFlightData.push(obj);
      //  }
      //}
      //if (this.revenueObj.isLocation == true) {
      //  for (let i = 0; i < this.selectedFromLocation.length; i++) {
      //    for (let j = 0; j < this.selectedToLocation.length; j++) {
      //      for (let k = 0; k < this.selectedVIALocation.length; k++) {
      //        let item = new RevenueManagementFlightLocationProperties();
      //        item.fromLocation = this.selectedFromLocation[i];
      //        item.toLocation = this.selectedToLocation[j];
      //        item.viaLocation = this.selectedVIALocation[k];
      //        item.isIncluded = true;
      //        this.revenueObj.flightLocationDataIncluded.push(item)
      //      }
      //    }
      //  }

      //  for (let i = 0; i < this.excludedFromLocation.length; i++) {
      //    for (let j = 0; j < this.excludedToLocation.length; j++) {
      //      for (let k = 0; k < this.excludedVIALocation.length; k++) {
      //        let item = new RevenueManagementFlightLocationProperties();
      //        item.fromLocation = this.excludedFromLocation[i];
      //        item.toLocation = this.excludedToLocation[j];
      //        item.viaLocation = this.excludedVIALocation[k];
      //        item.isIncluded = false;
      //        this.revenueObj.flightLocationDataExcluded.push(item)
      //      }
      //    }
      //  }
      //}
      if (this.flightCalculations.length > 0) {
        for (let i = 0; i < this.flightCalculations.length; i++) {
          let item = this.flightCalculations[i];
          item.rbd = item.selectedRbd.toString();
          this.revenueObj.flightCalaculationData.push(item);
        }
      }
      if (this.reveuecheckcriteria.length > 0) {
        for (let i = 0; i < this.revenueObj.suppliersData.length; i++) {
          for (let j = 0; j < this.revenueObj.flightCalaculationData.length; j++) {
            for (let k = 0; k < this.reveuecheckcriteria.length; k++) {
              if (this.revenueObj.suppliersData[i].supplierId == this.reveuecheckcriteria[k].supplierId) {
                //for (let pk = 0; this.reveuecheckcriteria[k].passengerType.length;pk++) {
                //  if (this.reveuecheckcriteria[k].passengerType == this.revenueObj.flightCalaculationData[j].passengerType) {
                //    if (this.reveuecheckcriteria[k].cabinClass == this.revenueObj.flightCalaculationData[j].cabinClass) {
                //      if (this.reveuecheckcriteria[k].rbd == this.revenueObj.flightCalaculationData[j].rbd) {
                //        if (this.reveuecheckcriteria[k].calculatedOn == this.revenueObj.flightCalaculationData[j].calculatedOn) {
                //          this.validatecheckmessage = "You Have Already Applied this Criteria! Please Change the Criteria or Use Old Criteria ";
                //          this.validateforwardmessage = "If You Want To use Old One Click On Yes Button";
                //          this.movedToRevenueOnYes = this.reveuecheckcriteria[k].revenueId;
                //          this.FallSuccess.open(targetmodel, {

                //            windowClass: "warningPopupmodal", centered: true
                //          })
                //          return;
                //        }
                //      }

                //    }


                //  }
                //}
             
              }

            }
          }

        }

      }
      this.revenueObj.creationUser = userId;
      this.revenueService.CreateRevenueManagementRefund(this.revenueObj).subscribe((data) => {
        if (data == true) {
          this.router.navigateByUrl('/revenueManagementList');
        }
        else {
          this.FallSuccess.open(model, {

            /* windowClass: "searchpassengerpopupmodal"*/
            windowClass: "alertpopupmodal"
          })
          return;
        }
      })

    }
  }
  hshsh(model) {
    this.FallSuccess.open(model, {

      /* windowClass: "searchpassengerpopupmodal"*/
      /*windowClass: "alertpopupmodal"*/
      windowClass: "warningPopupmodal", centered: true
    })
  }
  YesMovedToOldRevenue() {
    this.FallSuccess.dismissAll();
    localStorage.setItem('RevenueManagementListId', (this.movedToRevenueOnYes).toString());
    //this.router.navigateByUrl('/refundRevenue');
    this.ngOnInit();
  }

  RefundRequestUpdate(model) {
    if (this.revenueObj.name == undefined || this.revenueObj.name == "") {
      document.getElementById("messagename").innerHTML = "Required Name";
      document.getElementById("name").classList.add("newRequired-BoxColor");
      setTimeout(function () {
        document.getElementById("messagename").innerHTML = "";
        document.getElementById("name").classList.remove("newRequired-BoxColor");
      }, 6000);
      return;
    }
    if (this.revenueObj.agencyBranchList.length < 1) {
      document.getElementById("messageagency").innerHTML = "Required Agency";
      document.getElementById("agencybranch").classList.add("newRequired-BoxColor");
      setTimeout(function () {
        document.getElementById("messageagency").innerHTML = "";
        document.getElementById("agencybranch").classList.remove("newRequired-BoxColor");
      }, 6000);
      return;
    }
    //if (this.revenueObj.agencyId_BranchId == undefined || this.revenueObj.agencyId_BranchId == "") {
    //  document.getElementById("messageagency").innerHTML = "Required Agency";
    //  document.getElementById("agencybranch").classList.add("newRequired-BoxColor");
    //  setTimeout(function () {
    //    document.getElementById("messageagency").innerHTML = "";
    //    document.getElementById("agencybranch").classList.remove("newRequired-BoxColor");
    //  }, 6000);
    //  return;
    //}
    if (this.revenueObj.expiryDate == undefined || this.revenueObj.expiryDate == "") {
      document.getElementById("messageexpiryDate").innerHTML = "Required Date";
      document.getElementById("expiryDate").classList.add("newRequired-BoxColor");
      setTimeout(function () {
        document.getElementById("messageexpiryDate").innerHTML = "";
        document.getElementById("expiryDate").classList.remove("newRequired-BoxColor");
      }, 6000);
      return;
    }
    if (this.revenueObj.selectedSuppliersList == undefined || this.revenueObj.selectedSuppliersList.length == 0) {
      document.getElementById("messagesupplierd").innerHTML = "Required Supplier";
      document.getElementById("supplierd").classList.add("newRequired-BoxColor");
      setTimeout(function () {
        document.getElementById("messagesupplierd").innerHTML = "";
        document.getElementById("supplierd").classList.remove("newRequired-BoxColor");
      }, 6000);
      return;
    }
   if (this.revenueObj.selectedOficeIdsList.length == 0) {
      document.getElementById("messageisOficeId").innerHTML = "Required OfficeID";
      document.getElementById("abc").classList.add("newRequired-BoxColor");
      setTimeout(function () {
        document.getElementById("messageisOficeId").innerHTML = "";
        document.getElementById("abc").classList.remove("newRequired-BoxColor");
      }, 6000);
      return;
    }
    if (this.revenueObj.isOficeId == undefined || this.revenueObj.isOficeId == false) {
      document.getElementById("messageisOficeId").innerHTML = "Required OfficeID CheckBox";
      document.getElementById("checkoffice").classList.add("newRequired-BoxColor");
      setTimeout(function () {
        document.getElementById("messageisOficeId").innerHTML = "";
        document.getElementById("checkoffice").classList.remove("newRequired-BoxColor");
      }, 6000);
      return;
    }
    if (this.revenueObj.type == undefined || this.revenueObj.type == "" || this.revenueObj.type == null) {
      document.getElementById("messagetypesefe").innerHTML = "Required Type";

      setTimeout(function () {
        document.getElementById("messagetypesefe").innerHTML = "";

      }, 6000);
      return;
    }
    if (this.revenueObj.appliesOn.length == 0) {
      document.getElementById("messageApplied").innerHTML = "Required Applied";

      setTimeout(function () {
        document.getElementById("messageApplied").innerHTML = "";

      }, 6000);
      return;
    }
    //if (this.revenueObj.isTravelDate == true) {
    //  if (this.revenueObj.travelDateFrom.length <= 0) {
    //    document.getElementById("travelrequiredfrom").innerHTML = "Required From";

    //    setTimeout(function () {
    //      document.getElementById("travelrequiredfrom").innerHTML = "";

    //    }, 6000);
    //    return;
    //  }
    //  if (this.revenueObj.travelDateTo.length <= 0) {
    //    document.getElementById("travelrequiredto").innerHTML = "Required To";

    //    setTimeout(function () {
    //      document.getElementById("travelrequiredto").innerHTML = "";

    //    }, 6000);
    //    return;
    //  }
    //}

    //if (this.revenueObj.travelDateFrom.length > 0 && this.revenueObj.travelDateTo == "") {
    //  document.getElementById("travelrequiredto").innerHTML = "Required To";

    //  setTimeout(function () {
    //    document.getElementById("travelrequiredto").innerHTML = "";

    //  }, 6000);
    //  return;
    //}
    //if (this.revenueObj.travelDateTo.length > 0 && this.revenueObj.travelDateFrom == "") {
    //  document.getElementById("travelrequiredfrom").innerHTML = "Required From";

    //  setTimeout(function () {
    //    document.getElementById("travelrequiredfrom").innerHTML = "";

    //  }, 6000);
    //  return;
    //}
    //if (this.revenueObj.travelDateFrom.length > 0 && this.revenueObj.travelDateTo.length > 0) {
    //  if (this.revenueObj.travelDateFrom > this.revenueObj.travelDateTo) {
    //    document.getElementById("travelrequiredfrom").innerHTML = "Carefully select From Or To Date";

    //    setTimeout(function () {
    //      document.getElementById("travelrequiredfrom").innerHTML = "";

    //    }, 6000);
    //    return;
    //  }
    //}
    //if (this.revenueObj.isBookingDate == true) {
    //  if (this.revenueObj.bookingDateFrom.length <= 0) {
    //    document.getElementById("bookingdateform").innerHTML = "Required From";

    //    setTimeout(function () {
    //      document.getElementById("bookingdateform").innerHTML = "";

    //    }, 6000);
    //    return;
    //  }
    //  if (this.revenueObj.bookingDateTo.length <= 0) {
    //    document.getElementById("bookingdateto").innerHTML = "Required To";

    //    setTimeout(function () {
    //      document.getElementById("bookingdateto").innerHTML = "";

    //    }, 6000);
    //    return;
    //  }
    //}


    //if (this.revenueObj.bookingDateFrom.length > 0 && this.revenueObj.bookingDateTo == "") {
    //  document.getElementById("bookingdateto").innerHTML = "Required To";

    //  setTimeout(function () {
    //    document.getElementById("bookingdateto").innerHTML = "";

    //  }, 6000);
    //  return;
    //}
    //if (this.revenueObj.bookingDateTo.length > 0 && this.revenueObj.bookingDateFrom == "") {
    //  document.getElementById("bookingdateform").innerHTML = "Required From";

    //  setTimeout(function () {
    //    document.getElementById("bookingdateform").innerHTML = "";

    //  }, 6000);
    //  return;
    //}
    //if (this.revenueObj.bookingDateFrom.length > 0 && this.revenueObj.bookingDateTo.length > 0) {
    //  if (this.revenueObj.bookingDateFrom > this.revenueObj.bookingDateTo) {
    //    document.getElementById("bookingdateform").innerHTML = "Carefully select From Or To Date";

    //    setTimeout(function () {
    //      document.getElementById("bookingdateform").innerHTML = "";

    //    }, 6000);
    //    return;
    //  }
    //}
    if (this.flightCalculations.length < 1
      || this.flightCalculations.length == null) {
      this.saveData = false;

      document.getElementById("requirefldmsg").innerHTML = "Please Enter Calculation Data";

      setTimeout(function () {
        document.getElementById("requirefldmsg").innerHTML = "";

      }, 6000);
      return;

    }
    for (let i = 0; i < this.flightCalculations.length; i++) {
      if (this.flightCalculations[i].cabinClass == "" || this.flightCalculations[i].cabinClass == null
        || this.flightCalculations[i].calculatedOn == "" || this.flightCalculations[i].calculatedOn == null
        || this.flightCalculations[i].passengerType.length < 1  || this.flightCalculations[i].passengerType == null
        || this.flightCalculations[i].selectedRbd.length < 1 || this.flightCalculations[i].selectedRbd.length == null
        || (this.flightCalculations[i].valueAmount == 0 && this.flightCalculations[i].valuePercent == 0)) {
        document.getElementById("requirefldmsg").innerHTML = "Please Enter Calculation Data";

        setTimeout(function () {
          document.getElementById("requirefldmsg").innerHTML = "";

        }, 6000);
        return;
      }

      else {
        this.saveData = true;

      }
    }
    this.revenueObj.suppliersData = [];
    this.revenueObj.airlineFlightData = [];
    this.revenueObj.flightLocationDataIncluded = [];
    this.revenueObj.flightLocationDataExcluded = [];
    this.revenueObj.flightCalaculationData = [];
    if (this.revenueObj.selectedSuppliersList.length > 0 && this.revenueObj.selectedOficeIdsList.length > 0) {
      for (let i = 0; i < this.supplier_oficeIdData.length; i++) {
        for (let j = 0; j < this.revenueObj.selectedOficeIdsList.length; j++) {
          if (this.supplier_oficeIdData[i].officeId == this.revenueObj.selectedOficeIdsList[j]) {
            let obj = new RevenueManagementSupplierFlights;
            obj.officeId = this.supplier_oficeIdData[i].officeId;
            obj.supplierId = this.supplier_oficeIdData[i].supplierId;
            this.revenueObj.suppliersData.push(obj);
            break;
          }
        }
      }
      //for (let i = 0; i < this.supplier_oficeIdData.length; i++) {
      //  for (let j = 0; j < this.revenueObj.selectedOficeIdsList.length; j++) {
      //    if (this.supplier_oficeIdData[i].officeId == this.revenueObj.selectedOficeIdsList[j]) {
      //      let obj = new RevenueManagementSupplierFlights;
      //      obj.officeId = this.supplier_oficeIdData[i].officeId;
      //      obj.supplierId = this.supplier_oficeIdData[i].supplierId;
      //      obj.revenueSupplierId = this.suppliersDatanew[i].revenueSupplierId;
      //      this.revenueObj.suppliersData.push(obj);
      //      break;
      //    }
      //  }
      //}
    }
    //if (this.revenueObj.isValidatingAirline == true) {

    //  for (let i = 0; i < this.selectedValidatingAirline.length; i++) {
    //    let obj = new RevenueManagement_AirlineFlight();
    //    obj.airlineTypeId = 1;
    //    obj.airlineId = this.selectedValidatingAirline[i];
    //    this.revenueObj.airlineFlightData.push(obj);
    //  }
    //}
    //if (this.revenueObj.isMarketingAirline == true) {
    //  for (let i = 0; i < this.selectedMarkitingAirline.length; i++) {
    //    let obj = new RevenueManagement_AirlineFlight();
    //    obj.airlineTypeId = 2;
    //    obj.airlineId = this.selectedMarkitingAirline[i];
    //    this.revenueObj.airlineFlightData.push(obj);
    //  }
    //}

    //if (this.revenueObj.isOperatingAirline == true) {
    //  for (let i = 0; i < this.selectedOperatingAirline.length; i++) {
    //    let obj = new RevenueManagement_AirlineFlight();
    //    obj.airlineTypeId = 3;
    //    obj.airlineId = this.selectedOperatingAirline[i];
    //    this.revenueObj.airlineFlightData.push(obj);
    //  }
    //}
    //if (this.revenueObj.isLocation == true) {
    //  for (let i = 0; i < this.selectedFromLocation.length; i++) {
    //    for (let j = 0; j < this.selectedToLocation.length; j++) {
    //      for (let k = 0; k < this.selectedVIALocation.length; k++) {
    //        let item = new RevenueManagementFlightLocationProperties();
    //        item.fromLocation = this.selectedFromLocation[i];
    //        item.toLocation = this.selectedToLocation[j];
    //        item.viaLocation = this.selectedVIALocation[k];
    //        item.isIncluded = true;
    //        this.revenueObj.flightLocationDataIncluded.push(item)
    //      }
    //    }
    //  }

    //  for (let i = 0; i < this.excludedFromLocation.length; i++) {
    //    for (let j = 0; j < this.excludedToLocation.length; j++) {
    //      for (let k = 0; k < this.excludedVIALocation.length; k++) {
    //        let item = new RevenueManagementFlightLocationProperties();
    //        item.fromLocation = this.excludedFromLocation[i];
    //        item.toLocation = this.excludedToLocation[j];
    //        item.viaLocation = this.excludedVIALocation[k];
    //        item.isIncluded = false;
    //        this.revenueObj.flightLocationDataExcluded.push(item)
    //      }
    //    }
    //  }
    //}
    if (this.flightCalculations.length > 0) {
      for (let i = 0; i < this.flightCalculations.length; i++) {

        let item = this.flightCalculations[i];
        item.rbd = item.selectedRbd.toString();
        item.revenueCalculationId = 0;
        item.revenueId = 0;
        this.revenueObj.flightCalaculationData.push(item);
      }
    }
    let baseAgency = "";
    if (localStorage.getItem("AgencyId") != undefined &&
      localStorage.getItem("AgencyId") != null && localStorage.getItem("AgencyId") != "")
      baseAgency = localStorage.getItem("AgencyId");

    this.revenueObj.baseRuleAgency = baseAgency;
    let userId = Number(localStorage.getItem("UserId"))
    this.revenueObj.modifyUser = userId;


    this.revenueService.UpdateRevenueManagementRefund(this.revenueObj).subscribe((data) => {
      if (data == true) {
        this.router.navigateByUrl('/revenueManagementList');
      }
      else {
        this.FallSuccess.open(model, {

          /* windowClass: "searchpassengerpopupmodal"*/
          windowClass: "alertpopupmodal"
        })
        return;
      }
    })
  }
  ChangeType(typeValue) {
    try {
      if (typeValue == "ServiceFee") {
        this.isServiceFee = true;
        this.revenueObj.type = "ServiceFee"
      }
      else {
        this.isServiceFee = false;
        this.revenueObj.type = "";
      }
    }
    catch (e) {
    }
  }
  ChangeAppliesOn(appliesValue) {
    try {
      if (appliesValue == "Passenger") {
        this.isPassenger = true;
        this.isPNR = false;
        this.revenueObj.appliesOn = "Passenger"
      }
      else if (appliesValue == "PNR") {
        this.isPassenger = false;
        this.isPNR = true;
        this.revenueObj.appliesOn = "PNR"
      }
      else {
        this.isPassenger = false;
        this.isPNR = false;
        this.revenueObj.appliesOn = ""
      }
    }
    catch (e) {

    }
  }
  trvlchk(e) {
    if (e.target.value == "") {
      this.revenueObj.isTravelDate = false;
    } else {
      this.revenueObj.isTravelDate = true;
    }

  }
  bkchk(e) {
    if (e.target.value == "") {
      this.revenueObj.isBookingDate = false;
    } else {
      this.revenueObj.isBookingDate = true;
    }

  }
  lcchk(e) {
    if (e.target.value == "") {
      this.revenueObj.isLocation = false;
    } else {
      this.revenueObj.isLocation = true;
    }

  }

  FromAirportChange(selectedValues) {
    try {
      for (let i = 0; i < selectedValues.length; i++) {

        if (selectedValues[i] == "World Wide") {
          this.selectedFromLocation = [];
          //this.fromAirport.handleClearClick();
          this.selectedFromLocation.push("World Wide");
          break;
        }
        // //console.log(selectedValues[i]);
      }

      if (this.selectedFromLocation.length != 0) {
        this.revenueObj.isLocation = true;
      }
      if (this.selectedFromLocation.length <= 0 || this.selectedFromLocation.length == undefined) {
        this.revenueObj.isLocation = false;
      }


    }
    catch (e) {

    }

  }

  ToAirportChange(selectedValues) {
    try {
      for (let i = 0; i < selectedValues.length; i++) {
        if (selectedValues[i] == "World Wide") {
          this.selectedToLocation = [];
          //this.fromAirport.handleClearClick();
          this.selectedToLocation.push("World Wide");
          break;
        }
      }
    }
    catch (e) {

    }
  }
  valchk(e) {
    if (e.target.value == "") {
      this.revenueObj.isValidatingAirline = false;
    } else {
      this.revenueObj.isValidatingAirline = true;
    }
  }

  validatechk() {
    if (this.selectedValidatingAirline.length > 0) {
      this.revenueObj.isValidatingAirline = true;
    } else {
      this.revenueObj.isValidatingAirline = false;
    }

  }
  markchk(e) {
    if (e.target.value == "") {
      this.revenueObj.isMarketingAirline = false;
    } else {
      this.revenueObj.isMarketingAirline = true;
    }

  }
  marketingchk() {

    if (this.selectedMarkitingAirline.length > 0) {
      this.revenueObj.isMarketingAirline = true;
    } else {
      this.revenueObj.isMarketingAirline = false;
    }
  }
  operchk(e) {
    if (e.target.value == "") {
      this.revenueObj.isOperatingAirline = false;
    } else {
      this.revenueObj.isOperatingAirline = true;
    }

  }
  operatingchk() {

    if (this.selectedOperatingAirline.length > 0) {
      this.revenueObj.isOperatingAirline = true;
    } else {
      this.revenueObj.isOperatingAirline = false;
    }
  }
  AddFlightCalculation() {
    try {
      let obj = new RevenueManagementCalculationFlight();
      this.flightCalculations.push(obj);
    }
    catch (e) {
    }
  }
  DeleteFlightCalculation(index) {
    try {
      this.flightCalculations.splice(index, 1);
    }
    catch (e) {
    }
  }
  isValidExpiryDate(dateString) {

    const currentDate = new Date();
    const expDate = new Date(dateString);

    if (expDate < currentDate) {
      return false;
    }
  
    return true;

  }
  dateexpvalidate(exp) {
    if (!this.isValidExpiryDate(exp)) {
      document.getElementById("messageexpiryDate").innerHTML = "Future Dates Only";
      setTimeout(() => {
        document.getElementById("messageexpiryDate").innerHTML = "";
      }, 3000);
      return;
    }
  }
}

